if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 768px)');

        /**----------geeko 图片轮播 start-------------- **/
        const totalFromData = parseInt(this.elements.viewer?.dataset.mediaCount || '', 10);
        this.totalSlides = Number.isNaN(totalFromData) ? 0 : totalFromData;
        this.currentSlideIndex = 0;
        if (!this.totalSlides && this.elements.viewer) {
          this.totalSlides = this.elements.viewer.querySelectorAll('[data-media-id]').length;
        }
        this.progressBar = this.elements.viewer?.querySelector('[data-progress-bar]');
        this.updateProgressByIndex(0);

        if (this.elements.viewer) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.viewer.addEventListener('sliderTotalChanged', this.handleTotalChange.bind(this));
        }
         /**-----------geeko 图片轮播 end------------- **/

        if (!this.elements.thumbnails) return;

        /**----------geeko 图片轮播 start-------------- **/
        // this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        /**-----------geeko 图片轮播 end------------- **/
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      // onSlideChanged(event) {
      //   if (event.detail && event.detail.currentElement) {
      //     const currentElement = event.detail.currentElement;
      //     if (currentElement.dataset && currentElement.dataset.mediaId) {
      //       const thumbnail = this.elements.thumbnails.querySelector(
      //         `[data-target="${currentElement.dataset.mediaId}"]`
      //       );
      //       this.setActiveThumbnail(thumbnail);
      //     }
      //   }
      // }
      onSlideChanged(event) {
        if (event.detail && event.detail.currentElement) {
          const currentElement = event.detail.currentElement;
          if (currentElement.dataset && currentElement.dataset.mediaId) {
            /**-----------geeko图片轮播 start------------- **/
            if (event.detail.currentPage) {
              this.updateProgressByIndex(event.detail.currentPage - 1);
            } else {
              this.updateProgressByMediaId(currentElement.dataset.mediaId);
            }
            /**-----------geeko图片轮播 end------------- **/
            // Prevent resetting to the first image if a variant was selected
            if (this.elements.viewer.dataset.selectedMediaId && 
                this.elements.viewer.dataset.selectedMediaId !== currentElement.dataset.mediaId) {
                return;
            }
            const thumbnail = this.elements.thumbnails.querySelector(
                `[data-target="${currentElement.dataset.mediaId}"]`
            );
            this.setActiveThumbnail(thumbnail);
          }
        }
      }
       /**-----------geeko图片轮播 start------------- **/
      handleTotalChange(event) {
        const total = parseInt(event?.detail?.total, 10);
        if (Number.isNaN(total) || total <= 0) return;
        this.totalSlides = total;
        this.updateProgressByIndex(this.currentSlideIndex);
      }
      /**-----------geeko图片轮播 end------------- **/
      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }
        this.elements.viewer.dataset.selectedMediaId = mediaId;

         /**-----------geeko图片轮播 start------------- **/
        this.updateProgressByMediaId(mediaId);
        /**-----------geeko图片轮播 end------------- **/

        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      /**-----------geeko图片轮播 start------------- **/
      updateProgressByIndex(index = 0) {
        if (!this.progressBar || !this.totalSlides) return;
        const clampedIndex = Math.min(Math.max(index, 0), this.totalSlides - 1);
        const percentage = ((clampedIndex + 1) / this.totalSlides) * 100;
        this.progressBar.style.width = `${percentage}%`;
        this.currentSlideIndex = clampedIndex;
      }

      updateProgressByMediaId(mediaId) {
        if (!mediaId || !this.elements.viewer) return;
        const slides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
        if (index !== -1) {
          this.updateProgressByIndex(index);
        }
      }
       /**-----------geeko图片轮播 end------------- **/

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.setSlidePosition(thumbnail[this.elements.thumbnails.offsetLeft]);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
